var map = {
	"./add.svg": 4159,
	"./boluo.svg": 5278,
	"./cue.svg": 4555,
	"./details.svg": 5404,
	"./ear.svg": 7210,
	"./empty.svg": 2793,
	"./exercise.svg": 8292,
	"./guide.svg": 2330,
	"./headText.svg": 2597,
	"./health1.svg": 4237,
	"./health2.svg": 5118,
	"./health3.svg": 9871,
	"./health4.svg": 7664,
	"./heart.svg": 3214,
	"./hoop3.svg": 7043,
	"./list-empty.svg": 6130,
	"./load.svg": 8546,
	"./moon.svg": 6289,
	"./music.svg": 5623,
	"./pause.svg": 5872,
	"./play.svg": 2408,
	"./point.svg": 2312,
	"./right-arrow.svg": 1352,
	"./right-hoop.svg": 7479,
	"./right-hoop1.svg": 756,
	"./run.svg": 621,
	"./scale.svg": 5188,
	"./sleep.svg": 1507,
	"./sun.svg": 624,
	"./trophy.svg": 1024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;